var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2115",
    d: "M0-682.665H60v60H0Z",
    transform: "translate(0 682.665)",
    fill: "#06aa88"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product_master",
    "data-name": "Product master",
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2109",
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2113",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2119",
    transform: "translate(30 26.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2121",
    d: "M-264.5-220.023v4.286h-25.487v-25.487H-265.4a.9.9,0,0,1,.9.9v16.307",
    transform: "translate(289.985 241.225)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2123",
    transform: "translate(39.701 26.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2125",
    d: "M-31.577,0H-34.62V6.768a.536.536,0,0,0,.78.477l2.018-1.034a.536.536,0,0,1,.489,0l2.018,1.034a.536.536,0,0,0,.78-.477V0Z",
    transform: "translate(34.62)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2127",
    transform: "translate(37.934 42.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2129",
    d: "M-94.468-48.956h-8.586a.517.517,0,0,1-.516-.516v-3.684a.517.517,0,0,1,.516-.516h8.586a.516.516,0,0,1,.516.516v3.684A.516.516,0,0,1-94.468-48.956Z",
    transform: "translate(103.57 53.673)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2131",
    transform: "translate(17.256 0.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2133",
    d: "M0-96.525v16.186H25.487v-24.586a.9.9,0,0,0-.9-.9H.9a.9.9,0,0,0-.9.9v4.406",
    transform: "translate(0 105.826)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2135",
    transform: "translate(26.957 0.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2137",
    d: "M-31.577,0H-34.62V6.768a.536.536,0,0,0,.781.477l2.018-1.034a.536.536,0,0,1,.489,0l2.018,1.034a.536.536,0,0,0,.78-.477V0Z",
    transform: "translate(34.62)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2139",
    transform: "translate(25.19 17.325)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2141",
    d: "M-94.466-48.956h-8.586a.516.516,0,0,1-.516-.517v-3.684a.516.516,0,0,1,.516-.516h8.586a.516.516,0,0,1,.516.516v3.684A.516.516,0,0,1-94.466-48.956Z",
    transform: "translate(103.569 53.673)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2143",
    transform: "translate(4.513 26.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2145",
    d: "M-264.5-264.5h-25.487v-24.585a.9.9,0,0,1,.9-.9H-264.5Z",
    transform: "translate(289.986 289.985)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2147",
    transform: "translate(14.214 26.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2149",
    d: "M-31.577,0H-34.62V6.768a.536.536,0,0,0,.781.477l2.018-1.034a.535.535,0,0,1,.489,0l2.018,1.034a.536.536,0,0,0,.78-.477V0Z",
    transform: "translate(34.62)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2151",
    transform: "translate(12.447 42.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2153",
    d: "M-94.466-48.956h-8.586a.516.516,0,0,1-.516-.516v-3.684a.516.516,0,0,1,.516-.516h8.586a.516.516,0,0,1,.516.516v3.684A.516.516,0,0,1-94.466-48.956Z",
    transform: "translate(103.569 53.673)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2155",
    transform: "translate(0.853 51.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2157",
    d: "M-600.472-35.459H-657.9a.433.433,0,0,1-.432-.433v-2.552a.433.433,0,0,1,.432-.433h57.429a.433.433,0,0,1,.432.433v2.552A.433.433,0,0,1-600.472-35.459Z",
    transform: "translate(658.333 38.876)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2159",
    transform: "translate(51.842 55.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2161",
    d: "M-33.639-40.743H-36.2a.685.685,0,0,1-.685-.685v-3.241h3.926v3.241A.685.685,0,0,1-33.639-40.743Z",
    transform: "translate(36.88 44.669)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2163",
    transform: "translate(4.232 55.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2165",
    d: "M-33.639-40.743H-36.2a.685.685,0,0,1-.684-.685v-3.241h3.926v3.241A.685.685,0,0,1-33.639-40.743Z",
    transform: "translate(36.88 44.669)",
    fill: "rgba(0,0,0,0)",
    stroke: "#06c79f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMaster);
export default __webpack_public_path__ + "static/media/productMaster.cc23eb477d8a6283e251811d483e9ff5.svg";
export { ForwardRef as ReactComponent };